// extracted by mini-css-extract-plugin
module.exports = {"logosList":"SocialMedia_logosList__AXL1Y","socialMediaLogo":"SocialMedia_socialMediaLogo__1eg1Y"};